import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { candidateJobQueryKeys } from '@/modules/candidates/queries/queryKeys';
import { invalidateQuery } from '@/utils/queries';

interface DeclineCandidateJobParams {
  jobId: string;
  candidateId: string;
}

export const useDeclineCandidateJobMutation = () => {
  return useMutation({
    mutationFn: ({ jobId, candidateId }: DeclineCandidateJobParams) =>
      fetchClient.POST('/jobs/{jobId}/candidates/{candidateId}/decline', {
        params: {
          path: {
            jobId,
            candidateId,
          },
        },
      }),
    onSettled: (_data, _error, variables) => {
      const { jobId, candidateId } = variables;
      const detailQueryKey = candidateJobQueryKeys.detail(jobId, candidateId);
      const listQueryKey = candidateJobQueryKeys.lists(jobId);

      invalidateQuery(listQueryKey)();
      invalidateQuery(detailQueryKey)();
    },
  });
};
